import { render, staticRenderFns } from "./TargetGoalIcon.vue?vue&type=template&id=b530282a&scoped=true"
import script from "./TargetGoalIcon.vue?vue&type=script&lang=js"
export * from "./TargetGoalIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b530282a",
  null
  
)

export default component.exports